import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "QR Import", -1)
const _hoisted_2 = ["alt", "src"]

import { encode as encodeRecipe, Recipe } from 'fabri-core'
import * as QRCode from 'qrcode'

import { computed, onBeforeUpdate, onMounted, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
    recipe: null
  },
  setup(__props: any) {

const props = __props as {
  recipe: Recipe
}



const recipeProviderURL = computed(() =>
  `https://us-central1-bring-recipe-provider.cloudfunctions.net/recipes/${encodeRecipe(props.recipe)}`
)

const bringImportUrl = computed(() => `https://api.getbring.com/rest/bringrecipes/deeplink?url=${encodeURIComponent(recipeProviderURL.value)}&source=web&baseQuantity=4&requestedQuantity=4`)

const imageDataUrl = ref('')

async function updateQrCode () {
  const newimageDataUrl = await QRCode.toDataURL(bringImportUrl.value)
  if (imageDataUrl.value !== newimageDataUrl) {
    imageDataUrl.value = newimageDataUrl
  }
}

onMounted(() => {
  updateQrCode()
})

onBeforeUpdate(() => {
  updateQrCode()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("img", {
      alt: imageDataUrl.value,
      src: imageDataUrl.value
    }, null, 8, _hoisted_2)
  ], 64))
}
}

})